import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizQuestionLabel from "@/components/quiz/QuizQuestionLabel.vue";
import WSelect from "@/components/form/w-select.vue";
import QuizUtils from "@/util/quizUtils";
import QuizQuestionCorrectionExplanation from "@/components/questions/QuizQuestionCorrectionExplanation.vue";
import { range, shuffle } from "lodash";
import QuizAnswersValidationAlert from "@/components/quiz/QuizAnswersValidationAlert.vue";
let QuizSortingQuestion = class QuizSortingQuestion extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", void 0);
    _defineProperty(this, "userItemsSorting", void 0);
    _defineProperty(this, "questionCustomLabel", '');
    _defineProperty(this, "displayOverallVerdictIcon", false);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "displayAnswersValidationAlert", void 0);
    _defineProperty(this, "answersValidationState", void 0);
    _defineProperty(this, "realtimeUserItemsSorting", []);
    _defineProperty(this, "dragStartIndex", null);
    _defineProperty(this, "dragOverIndex", null);
  }
  mounted() {
    this.initRealtimeUserItemsSorting();
  }
  initRealtimeUserItemsSorting() {
    if (this.userItemsSorting?.length) {
      this.realtimeUserItemsSorting = structuredClone(this.userItemsSorting);
    } else {
      this.realtimeUserItemsSorting = this.question.sortingItems.map(item => ({
        itemId: item.id,
        position: item.position
      }));
      this.realtimeUserItemsSorting = this.shufflePositions(this.realtimeUserItemsSorting);
      this.realtimeUserItemsSorting.sort((a, b) => a.position - b.position);
    }
  }
  get overallAnswersVerdictIcon() {
    return this.allPairsMatchingAreCorrect ? 'check-circle-outline' : 'close-circle-outline';
  }
  get overallVerdictIconClass() {
    return this.allPairsMatchingAreCorrect ? 'is-success' : 'is-failure';
  }
  get allPairsMatchingAreCorrect() {
    return this.question.matchingPairs.every(pair => QuizUtils.isPairMatchingCorrect(pair, this.realtimeUserItemsSorting));
  }
  getItemValue(itemId) {
    return this.question.sortingItems.find(item => item.id === itemId)?.value || '';
  }
  getItemImagePath(itemId) {
    const item = this.question.sortingItems.find(item => item.id === itemId);
    return item?.image?.imagePath || '';
  }
  getItemImageLabel(itemId) {
    const item = this.question.sortingItems.find(item => item.id === itemId);
    return item?.image?.imageLabel || '';
  }
  getItemCorrectPosition(itemId) {
    const correctPosition = this.question.sortingItems.find(item => item.id === itemId)?.position;
    return correctPosition ? `${correctPosition}` : '';
  }
  shufflePositions(items) {
    if (items.length < 2) {
      return items;
    }
    const shuffled = structuredClone(items);
    const positions = range(1, items.length + 1);
    let shuffledPositions;
    let attempts = 0;
    while (attempts < 100) {
      shuffledPositions = shuffle(positions);
      const isValid = items.every((item, index) => shuffledPositions[index] !== item.position);
      if (isValid) {
        shuffled.forEach((item, index) => {
          item.position = shuffledPositions[index];
        });
        return shuffled;
      }
      attempts++;
    }
    // Failed to generate valid shuffle after 100 attempts. We invert position of the two first items
    [shuffled[0].position, shuffled[1].position] = [shuffled[1].position, shuffled[0].position];
    return shuffled;
  }
  answerStatusClass(userSortedItem) {
    if (this.isResultMode) {
      return this.isUserSortedItemGoodPosition(userSortedItem) ? 'is-success' : 'is-failure';
    }
    return '';
  }
  isUserSortedItemGoodPosition(userSortedItem) {
    return this.question.sortingItems.find(item => item.id === userSortedItem.itemId)?.position === userSortedItem.position;
  }
  shouldDisplayItemsSortingCorrection(userSortedItem) {
    return this.isResultMode && !this.isUserSortedItemGoodPosition(userSortedItem);
  }
  answerStatusIcon(userSortedItem) {
    return this.isUserSortedItemGoodPosition(userSortedItem) ? 'check-circle-outline' : 'close-circle-outline';
  }
  onDragStart(index) {
    this.dragStartIndex = index;
    this.dragOverIndex = index;
  }
  onDragEnter(index) {
    this.dragOverIndex = index;
  }
  onDragEnd() {
    this.dragStartIndex = null;
    this.dragOverIndex = null;
  }
  onDrop(index) {
    if (this.dragStartIndex === null) return;
    const from = this.dragStartIndex;
    const to = index;
    if (from !== to) {
      const moved = this.realtimeUserItemsSorting[from];
      const remaining = this.realtimeUserItemsSorting.filter((_, i) => i !== from);
      remaining.splice(to, 0, moved);
      this.realtimeUserItemsSorting = remaining;
      this.$nextTick(() => {
        this.renumberRealtimeItemsPositions();
        this.emitItemsSortingUpdate();
      });
    }
    this.onDragEnd();
  }
  renumberRealtimeItemsPositions() {
    this.realtimeUserItemsSorting.forEach((item, index) => item.position = index + 1);
  }
  emitItemsSortingUpdate() {
    return this.realtimeUserItemsSorting;
  }
};
__decorate([Prop({
  required: true
})], QuizSortingQuestion.prototype, "question", void 0);
__decorate([Prop({
  default: []
})], QuizSortingQuestion.prototype, "userItemsSorting", void 0);
__decorate([Prop], QuizSortingQuestion.prototype, "questionCustomLabel", void 0);
__decorate([Prop], QuizSortingQuestion.prototype, "displayOverallVerdictIcon", void 0);
__decorate([Prop({
  default: false
})], QuizSortingQuestion.prototype, "isResultMode", void 0);
__decorate([Prop({
  default: false
})], QuizSortingQuestion.prototype, "displayAnswersValidationAlert", void 0);
__decorate([Prop({
  default: null
})], QuizSortingQuestion.prototype, "answersValidationState", void 0);
__decorate([Emit("userItemsSortingUpdate")], QuizSortingQuestion.prototype, "emitItemsSortingUpdate", null);
QuizSortingQuestion = __decorate([Component({
  components: {
    QuizAnswersValidationAlert,
    QuizQuestionCorrectionExplanation,
    WSelect,
    QuizQuestionLabel,
    WInput
  }
})], QuizSortingQuestion);
export default QuizSortingQuestion;